/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Track
 */
export interface Track {
    /**
     * The GeoJSON type of the track
     * @type {string}
     * @memberof Track
     */
    type: TrackTypeEnum;
    /**
     * Array of position points with additional data
     * @type {Array<Array<string>>}
     * @memberof Track
     */
    coordinates: Array<Array<string>>;
    /**
     * Names of the extended properties in coordinates beyond lon/lat
     * @type {Array<string>}
     * @memberof Track
     */
    extensions: Array<string>;
}


/**
 * @export
 */
export const TrackTypeEnum = {
    LineString: 'LineString'
} as const;
export type TrackTypeEnum = typeof TrackTypeEnum[keyof typeof TrackTypeEnum];


/**
 * Check if a given object implements the Track interface.
 */
export function instanceOfTrack(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "coordinates" in value;
    isInstance = isInstance && "extensions" in value;

    return isInstance;
}

export function TrackFromJSON(json: any): Track {
    return TrackFromJSONTyped(json, false);
}

export function TrackFromJSONTyped(json: any, ignoreDiscriminator: boolean): Track {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
        'extensions': json['extensions'],
    };
}

export function TrackToJSON(value?: Track | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'coordinates': value.coordinates,
        'extensions': value.extensions,
    };
}

